import { useMemo, useState } from 'react';

const VISIBLE_ROLE_COUNT = 2;

/**
 * Collapsible role chip row for the user drawer, matching CoordioCore's `DrawerRolesChips`.
 *
 * Shows the first two roles as purple outlined chips and a "Show N more" toggle for the rest.
 */
export function DrawerRolesChips({ roles }: { roles: string[] }) {
  const [expanded, setExpanded] = useState(false);
  const uniqueRoles = useMemo(() => {
    const seen = new Set<string>();
    return roles.filter((r) => {
      if (seen.has(r)) return false;
      seen.add(r);
      return true;
    });
  }, [roles]);
  const visible = expanded ? uniqueRoles : uniqueRoles.slice(0, VISIBLE_ROLE_COUNT);
  const hiddenCount = uniqueRoles.length - VISIBLE_ROLE_COUNT;

  return (
    <div className="cortex-shell__drawer-roles">
      <span className="cortex-shell__drawer-info-label">Roles</span>
      <div className="cortex-shell__drawer-roles-chips">
        {visible.map((role, index) => (
          <span key={`${role}-${index}`} className="cortex-shell__drawer-role-chip">
            {role}
          </span>
        ))}
        {!expanded && hiddenCount > 0 ? (
          <button
            type="button"
            className="cortex-shell__drawer-roles-more"
            onClick={() => setExpanded(true)}
          >
            Show {hiddenCount} more
          </button>
        ) : null}
        {expanded && uniqueRoles.length > VISIBLE_ROLE_COUNT ? (
          <button
            type="button"
            className="cortex-shell__drawer-roles-more"
            onClick={() => setExpanded(false)}
          >
            Show less
          </button>
        ) : null}
      </div>
    </div>
  );
}
